import z from "zod";

/**
 * AvaliacaoOrdemCompraColetaSchema
 */

export const AvaliacaoOrdemCompraColetaSchema = z.object({
  produtosServicos: z.array(z.object({
    idProdutoServico: z.coerce.number(),
    tipo: z.string().nullable().default(null),
    quantidade: z.coerce.number().nullable().default(null),
    quantidadeRestante: z.coerce.number().nullable().default(null),
    quantidadeRecebida: z.coerce.number().nullable().default(null),
    observacao: z.string().nullable().default(null),
  })),
  nroNotaFiscal: z.coerce.string().nullable().default(null),
  dataEntrega: z.coerce.date({ required_error: 'Este campo deve ser preenchido!', invalid_type_error: 'Este campo deve ser preenchido!' }),
  arquivo: z.instanceof(File).nullable().default(null),
  limparArquivo: z.boolean().default(false),
  registrarEntradaEstoque: z.boolean().default(false),
});

/**
 * AvaliacaoOrdemCompraColetaForm
 */

export type AvaliacaoOrdemCompraColetaForm = z.infer<typeof AvaliacaoOrdemCompraColetaSchema>;
